import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledSelect, selectStyle } from './Select';

const Li = styled.li.attrs({
  className: 'flex flex-1 flex-col mb-3 md:mb-0 align-center justify-center'
})``;

const InputField = styled.input.attrs({
  className: 'form-control text-base h-15 py-3 '
})``;

/**
 *
 * @param {array} age_groups
 * @param {object} skills
 * @param {array} time_durations
 * @returns
 */
const SearchFilters = ({
  age_groups,
  time_durations,
  skills
}) => {

  const parseOptions = (o) => o.map((a) => ({ label: a, value: a }));

  const parseSkillsOptions = (s) => {
    const options = [];
    const skill = Object.values(s);
    const categories = Object.keys(s);
    categories.map((category, index) => {
      options.push({
        label: category,
        options: skill[index].map((a) => {
          return {
            label: a,
            value: a
          }
        })
      });
    });

    return options;
  }

  return (
    <form method='get' action='/activities/filtered'>
      <ul className='max-w-4xl mx-auto m-0 w-full flex flex-col md:flex-row list-none'>
        <Li>
          <StyledSelect
            name="activity[age_groups][]"
            placeholder="Any Age"
            options={parseOptions(age_groups)}
            styles={selectStyle}
          />
        </Li>
        <Li>
          <StyledSelect
            name="activity[time_durations][]"
            options={parseOptions(time_durations)}
            placeholder="Any Time"
            styles={selectStyle}
          />
        </Li>
        <Li>
          <StyledSelect
            name="activity[skills][]"
            placeholder="Any Skill"
            options={parseSkillsOptions(skills)}
            styles={{
              ...selectStyle,
              menu: (styles) => ({
                ...styles,
                width: '100%',
                "@media (min-width: 1024px)": {
                  width: '200px'
                }
              })
            }}
          />
        </Li>
        <Li>
          <InputField name="activity[keyword]" placeholder="Keyword" type="text" maxLength="12" />
        </Li>
        <Li>
          <button type='submit' className='btn btn-solid'>
            Search
          </button>
        </Li>
      </ul>
    </form>
  )
}

SearchFilters.propTypes = {
  age_groups: PropTypes.array,
  time_durations: PropTypes.array,
  skills: PropTypes.object,
}

export default SearchFilters;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Activities/SearchFilters/index.jsx